// React
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Internal Components
import {
  CreateDayIconV2,
  SaveIcon,
  PreviousDay,
} from "../../../components/ui/Icons/Icon";
import AiVoiceCapture from "../../../features/voice/AiVoiceCapture";
import { isDayComplete } from "../../../utils/dayProgress";

function DayDock({
  load,
  handleSubmit,
  dayList,
  today,
  previousDay,
  handleTodayAiChange,
}) {
  const navigate = useNavigate();

  const [saveTooltip, setSaveTooltip] = useState("");

  const handleTooltipChange = () => {
    setSaveTooltip("Saving...");
    setTimeout(() => {
      setSaveTooltip("Saved");
    }, 1200);
  };

  const [createDayState, setCreateDayState] = useState({
    active: true,
    text: "",
  });

  const [previousDayState, setPreviousDayState] = useState({
    active: true,
    text: "",
  });

  const createDayHandler = () => {
    // Matches FullDock: a day is finished when it is dated, scored, and every
    // moment written about has a score. The old check was `!today.endScore`,
    // which read a genuine score of 0 as unscored.
    if (today && !isDayComplete(today)) {
      setCreateDayState((prevState) => {
        let shallow = { ...prevState };
        shallow.active = false;
        shallow.text = "Finish this day to start a new one.";
        return shallow;
      });
    } else {
      setCreateDayState((prevState) => {
        let shallow = { ...prevState };
        shallow.active = true;
        shallow.text = "Ready to start a new day?";
        return shallow;
      });
    }
  };

  useEffect(() => {
    createDayHandler();
  }, [today]);

  const previousDayHandler = () => {
    if (!previousDay) {
      setPreviousDayState((prevState) => {
        let shallow = { ...prevState };
        shallow.active = false;
        shallow.text = "You are yet to log multiple days.";
        return shallow;
      });
    } else {
      setPreviousDayState((prevState) => {
        let shallow = { ...prevState };
        shallow.active = true;
        shallow.text = "Look back at the previous day.";
        return shallow;
      });
    }
  };

  useEffect(() => {
    previousDayHandler();
  }, [previousDay]);

  return (
    <div className="hidedock--container">
      <div className={`hidedock node`} data-tooltip={createDayState.text}>
        {createDayState.active ? (
          <a href={"/today"}>
            <CreateDayIconV2 />
          </a>
        ) : (
          <CreateDayIconV2 opacity="0.5" />
        )}
      </div>
      <div className={`hidedock node`}>
        {previousDayState.active ? (
          <a href={previousDay}>
            <PreviousDay />
          </a>
        ) : (
          <PreviousDay opacity="0.5" />
        )}
      </div>
      {/* <AiVoiceCapture handleTodayAiChange={handleTodayAiChange} /> */}
      <div
        className={`hidedock node_save ${load}`}
        data-tooltip={load === "success" ? saveTooltip : "Click to Save"}
        onClick={(e) => {
          handleSubmit(e);
          handleTooltipChange();
        }}
      >
        <SaveIcon load={load} />
      </div>
    </div>
  );
}

export default DayDock;
